import { connect } from 'react-redux';
import { stopSpeaking, playAvatarAudio, setReadyToAnimate } from './avatarActions';
import { blockScreen, unblockScreen, setIsFileLoadingFailed } from '../screen/screenActions';
import selectors from '../../rootSelectors';
import { GENERAL_AUDIO_DELAY } from '../../constants/time';
import AvatarView from './avatarView';

const mapStateToProps = (state) => ({
    isSpeaking: selectors.getAvatarSpeaking(state),
    isScreenBlocked: selectors.getIsScreenBlocked(state),
    isScreenGreyedOut: selectors.getIsScreenGreyedOut(state),
    position: selectors.getAvatarPosition(state),
    instructions: selectors.getAvatarInstructions(state),
    postAudioCallback: selectors.getPostAudioCallback(state),
    onTransitionEnd: selectors.getAvatarOnTransitionEnd(state),
    owlyCanSpeak: selectors.getAvatarCanSpeak(state)
});

const mapDispatchToProps = (dispatch) => ({
    stopSpeaking: () => {
        dispatch(stopSpeaking());
    },
    onClick: (instructions, postAudioCallback) => {
        if (!instructions || instructions.length === 0) {
            return Promise.resolve();
        }
        dispatch(blockScreen());
        return dispatch(playAvatarAudio(instructions, GENERAL_AUDIO_DELAY))
            .then(() => {
                if (postAudioCallback !== undefined) {
                    return dispatch(postAudioCallback());
                }
                return Promise.resolve();
            })
            .then(() => {
                dispatch(unblockScreen());
            });
    },
    onAnimationReady: () => {
        dispatch(setReadyToAnimate());
    },
    onFileLoadingError: () => {
        dispatch(setIsFileLoadingFailed(true));
    },
});

const AvatarContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(AvatarView);

export default AvatarContainer;
